import { render } from "./user-account-set-avatar.vue?vue&type=template&id=7d3cff8a"
import script from "./user-account-set-avatar.vue?vue&type=script&lang=js"
export * from "./user-account-set-avatar.vue?vue&type=script&lang=js"
script.render = render

export default script